import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRendererFormState } from "../../../../store/slices/commonSlice";
import FormGroupWrapper from "./FormGroupWrapper";
import Select from "react-select";
import { labelUtils } from "../Util";

const CustomMultiSelect = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  const [optionsMulti, setOptionsMulti] = useState([]);
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();
  const key = databaseKey || displayLabelKey;
  const required = fieldEle?.["display-required"] === 1;

  useEffect(() => {
    const optMultiArray = fieldEle?.["data-customvalue"]?.split("#") || [];
    const options = optMultiArray.map((opt) => ({
      key: opt,
      value: opt,
      label: opt,
    }));
    setOptionsMulti(options);
  }, [fieldEle]);

  useEffect(() => {
    const fieldValue = formState[key];
    if (required && (!fieldValue || fieldValue.length === 0)) {
      setError("This field is required");
    } else {
      setError("");
    }
  }, [formState, key, required]);

  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    dispatch(setRendererFormState({ key, value: selectedValues }));
    setError("");
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    dispatch(setRendererFormState({ key, value: selectedValues }));
  };

  const handleBlur = () => {
    const fieldValue = formState[key];
    if (required && (!fieldValue || fieldValue.length === 0)) {
      setError("This field is required");
    } else {
      setError("");
    }
  };

  const selectedValues = optionsMulti.filter((option) =>
    formState[key]?.includes(option.value)
  );

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div style={{ display: "none" }}>
          <input
            type="text"
            required={required}
            value={formState[key] || ""}
            onChange={(e) => handleInputChange(e)}
            onBlur={handleBlur}
          />
        </div>

        <Select
          id={newElfromJSON}
          name={key}
          options={optionsMulti}
          placeholder={fieldEle?.["display-placeholder"]}
          isMulti
          isDisabled={fieldEle?.["display-disabled"] === 1}
          isRequired={required}
          value={selectedValues}
          onChange={handleChange}
          onBlur={handleBlur}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
        />

        {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}

        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomMultiSelect;
